/* SK-theme: horizontale snap-slider met pijlknoppen. */
class SkSlider extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.sk-slider__track');
    this.prevButton = this.querySelector('.sk-slider__btn--prev');
    this.nextButton = this.querySelector('.sk-slider__btn--next');
    if (!this.track) return;

    if (this.prevButton) this.prevButton.addEventListener('click', () => this.scrollByPage(-1));
    if (this.nextButton) this.nextButton.addEventListener('click', () => this.scrollByPage(1));
    this.track.addEventListener('scroll', () => this.updateButtons(), { passive: true });
    window.addEventListener('resize', () => this.updateButtons(), { passive: true });
    this.updateButtons();
  }

  scrollByPage(direction) {
    const item = this.track.querySelector('.sk-slider__item');
    const step = item ? item.getBoundingClientRect().width + 12 : this.track.clientWidth * 0.8;
    const visible = Math.max(1, Math.floor(this.track.clientWidth / step));
    this.track.scrollBy({ left: direction * step * visible, behavior: 'smooth' });
  }

  updateButtons() {
    if (!this.prevButton && !this.nextButton) return;
    const maxScroll = this.track.scrollWidth - this.track.clientWidth;
    const atStart = this.track.scrollLeft <= 4;
    const atEnd = this.track.scrollLeft >= maxScroll - 4;
    const overflows = maxScroll > 4;
    if (this.prevButton) this.prevButton.toggleAttribute('disabled', atStart || !overflows);
    if (this.nextButton) this.nextButton.toggleAttribute('disabled', atEnd || !overflows);
  }
}

customElements.define('sk-slider', SkSlider);
